// src/pages/client/components/NotificationList.tsx
import type { Notification } from '@/domains/client/services/client.service';

interface NotificationListProps {
    notifications: Notification[];
    loading: boolean;
}

export default function NotificationList({ notifications, loading }: NotificationListProps) {
    return (
        <div className="space-y-6">
            <h2 className="text-2xl font-bold text-gray-900">Notifications</h2>

            {loading ? (
                <div className="text-center py-12">Chargement...</div>
            ) : notifications.length === 0 ? (
                <div className="bg-white rounded-2xl p-12 text-center">
                    <i className="ri-notification-off-line text-5xl text-gray-300"></i>
                    <p className="mt-4 text-gray-500">Aucune notification pour le moment</p>
                </div>
            ) : (
                <div className="space-y-3">
                    {notifications.map((notif) => (
                        <div
                            key={notif.id}
                            className={`p-5 rounded-2xl border transition-all ${notif.est_lu ? 'bg-gray-50 border-gray-200' : 'bg-white border-teal-200 shadow-sm'
                                }`}
                        >
                            <div className="flex justify-between">
                                <h4 className="font-semibold">{notif.titre}</h4>
                                {!notif.est_lu && <div className="w-2 h-2 bg-teal-500 rounded-full mt-2"></div>}
                            </div>
                            <p className="text-gray-600 mt-1">{notif.message}</p>
                            <p className="text-xs text-gray-400 mt-3">
                                {new Date(notif.created_at).toLocaleDateString('fr-FR', { hour: '2-digit', minute: '2-digit' })}
                            </p>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}